import { KC_PaddingEnum } from "../model/KC_PaddingEnum";

export const getPaddingClass = (
  paddingType: KC_PaddingEnum = KC_PaddingEnum.default
): string => {
  const paddingMap: Record<KC_PaddingEnum, string> = {
    [KC_PaddingEnum.default]: " card-padding-default",
    [KC_PaddingEnum.even]: " card-padding-event",
    [KC_PaddingEnum.cta]: " card-padding-cta",
    [KC_PaddingEnum.gift]: " card-padding-gift",
    [KC_PaddingEnum.none]: " card-padding-none"
  };
  return paddingMap[paddingType];
};
